export default __webpack_public_path__ + "static/media/jack-smith@2x.c636aca1.jpg";